"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SimpleButton_1 = __importDefault(require("./SimpleButton"));
var helpers_1 = require("../../helpers");
var AXSIcon_1 = __importDefault(require("../../elements/AXSIcon"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var IconButton = function (_a) {
    var borderless = _a.borderless, children = _a.children, className = _a.className, color = _a.color, disabled = _a.disabled, icon = _a.icon, iconPosition = _a.iconPosition, iconSize = _a.iconSize, iconAlign = _a.iconAlign, secondary = _a.secondary, size = _a.size, theme = _a.theme, props = __rest(_a, ["borderless", "children", "className", "color", "disabled", "icon", "iconPosition", "iconSize", "iconAlign", "secondary", "size", "theme"]);
    var Span = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    vertical-align: ", " !important;\n    margin-right: ", ";\n    margin-left: ", ";\n  "], ["\n    vertical-align: ", " !important;\n    margin-right: ",
        ";\n    margin-left: ",
        ";\n  "])), function (_a) {
        var size = _a.size, iconAlign = _a.iconAlign;
        return iconAlign ? iconAlign : (size === 'mini' ? '0' : '-2px');
    }, function (_a) {
        var iconPosition = _a.iconPosition;
        return iconPosition === 'before' || !iconPosition ? '3px' : '';
    }, function (_a) {
        var iconPosition = _a.iconPosition;
        return iconPosition !== 'before' ? '3px' : '';
    });
    var AXSButton = styled_components_1.default(SimpleButton_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    fill: ", ";\n\n    &:hover {\n      fill: ", ";\n    }\n  "], ["\n    fill: ",
        ";\n\n    &:hover {\n      fill: ",
        ";\n    }\n  "])), function (_a) {
        var secondary = _a.secondary, disabled = _a.disabled, theme = _a.theme;
        return helpers_1.setIconColor(secondary, disabled, theme);
    }, function (_a) {
        var disabled = _a.disabled, theme = _a.theme;
        return disabled
            ? utils_1.parseThemePath('theme.axsui.components.buttons.primary.disabled', theme, colors_1.colors.WHITE)
            : 'white';
    });
    var iconWrapper = (React.createElement(Span, { secondary: secondary, key: "icon", iconAlign: iconAlign, size: size },
        React.createElement(AXSIcon_1.default, { name: icon, size: helpers_1.setIconSize(size, iconSize), style: { verticalAlign: iconAlign ? iconAlign : 'text-top' }, theme: theme, color: "inherit" })));
    var iconText = [children];
    iconPosition === 'before'
        ? iconText.unshift(iconWrapper)
        : iconText.push(iconWrapper);
    return (React.createElement(AXSButton, __assign({ size: size, theme: theme, disabled: disabled, secondary: secondary, className: className ? className + " c-axs-button" : 'c-axs-button', borderless: borderless, color: color }, props), iconText));
};
IconButton.defaultProps = {
    disabled: false,
    secondary: false,
    size: 'medium',
};
/** @component */
exports.default = IconButton;
var templateObject_1, templateObject_2;
//# sourceMappingURL=IconButton.js.map